import { useMemo } from 'react';
import { ANNOTATION_TYPE } from '../../image/labelling/constants';
import { filterDynamicAnswers } from '../../image/labelling/reducers/utils/utils';
import { getDynamicAttributes } from '../../image/labelling-v2/components/side-panel/utils';
import type { DynamicAnswerSpanT } from '../../image/labelling-v2/studio-store/types';
import type { ModernizedGenericAnnotation } from '../../modernization-common/side-panel';
import { REVIEW_ANNOTATION_TYPE } from '../review-mode-side-panel/constants';
import type { ReviewAnnotationAttributesT, ReviewAnnotationInstanceT, ReviewAnnotationT } from '../review-mode-side-panel/types';
import type { RangeSpanT } from '../types/types';
export { FRAME_CLASSIFICATION_ID } from '../review-mode-side-panel/constants';
type UseFrameClassificationAnnotationProps = {
  annotations: ModernizedGenericAnnotation[];
  annotationIdToSpanMap: {
    [key: string]: RangeSpanT[];
  };
  getAnnotationDynamicAnswers: (id: string) => DynamicAnswerSpanT[];
};
export const useFrameClassificationAnnotation = ({
  annotations,
  annotationIdToSpanMap,
  getAnnotationDynamicAnswers
}: UseFrameClassificationAnnotationProps): ReviewAnnotationT | null => useMemo(() => {
  const frameClassificationAnnotations = annotations.filter(a => a.annotationType === ANNOTATION_TYPE.FRAME_CLASSIFICATION);
  if (frameClassificationAnnotations.length === 0) return null;
  const allInstances: ReviewAnnotationInstanceT[] = [];
  const allAttributes: ReviewAnnotationAttributesT[] = [];
  frameClassificationAnnotations.forEach(annotationInfo => {
    const answers = annotationInfo.metadata?.answers || {};
    const staticAnswers = filterDynamicAnswers(answers);
    const classificationAttributes = Object.values(staticAnswers).map(({
      question,
      answers
    }) => ({
      question,
      answers
    }));
    const rangeSpan = annotationIdToSpanMap[annotationInfo.id];
    const dynamicAttributes = getDynamicAttributes(annotationInfo.id, rangeSpan, getAnnotationDynamicAnswers(annotationInfo.id));
    const instances = (rangeSpan || []).map(instance => ({
      key: 'Frame',
      startIndex: instance.start + 1,
      endIndex: instance.end + 1
    }));
    instances.forEach(instance => {
      allInstances.push(instance);
      allAttributes.push({
        classificationAttributes,
        dynamicAttributes
      });
    });
  });
  if (allInstances.length === 0) return null;
  return {
    type: REVIEW_ANNOTATION_TYPE.ANNOTATION,
    name: 'Frame Classification',
    label: 'Frame Classification',
    instances: allInstances,
    attributes: allAttributes,
    hidden: false
  };
}, [annotations, annotationIdToSpanMap, getAnnotationDynamicAnswers]);